import { Incident } from "./types";

export type AlertDocAction = "hidden" | "view" | "confirm" | "reconfirm";

/** Which button the alert page shows. The server enforces the same rule. */
export function alertDocumentationAction(input: {
  enabled: boolean;
  threatStatus?: string | null;
  incident?: Pick<Incident, "status" | "confirmed_at" | "false_alert"> | null;
}): AlertDocAction {
  if (!input.enabled) return "hidden";
  const incident = input.incident || null;
  if (!incident) return input.threatStatus === "Resolved" ? "reconfirm" : "confirm";
  if (incident.status === "submitted_locked") return "view";
  if (incident.status === "closed" && !incident.false_alert) return "view";
  if (incident.status === "closed" || incident.status === "false_alert_pending_confirm") return "reconfirm";
  if (incident.confirmed_at) return "view";
  if (input.threatStatus === "Resolved") return "reconfirm";
  return "confirm";
}
